<template>
<div>
  <b-modal
      id="modal-xl"
      ref="modal-note"
      no-close-on-backdrop
      ok-title="Close"
      scrollable
      button-size="sm"
      size="lg"
      title="Quick Note"
    >
   <!-- <b-form-textarea
    id="textarea-rows"
    placeholder="Quick note for yourself (Only visible to you)"
    v-model="note.note"
    rows="20"
  /> -->
    <quill-editor
      class="quick-note-editor"
      v-model="note.note"
      :options="editorOption"
      >
      <div
        id="toolbar"
        slot="toolbar"
      >
        <!-- Add a bold button -->
        <button class="ql-bold">
          Bold
        </button>
        <button class="ql-italic">
          Italic
        </button>
        <button class="ql-underline">
          Underline
        </button>
        <button class="ql-strike">
          Strike
        </button>
        <!-- Add font size dropdown -->
        <select class="ql-size">
          <option value="small" />
          <!-- Note a missing, thus falsy value, is used to reset to default -->
          <option selected />
          <option value="large" />
          <option value="huge" />
        </select>

        <select class="ql-font">
          <option selected="selected" />
          <option value="serif" />
          <option value="monospace" />
        </select>

        <select class="ql-color" />
        <select class="ql-background" />
  <button class="ql-list" value="ordered"></button>
  <button class="ql-list" value="bullet"></button>
        <!-- Add subscript and superscript buttons -->
        <!-- <button
          class="ql-script"
          value="sub"
        />
        <button
          class="ql-script"
          value="super"
        /> -->

        <!-- You can also add your own -->
        <!-- <button
          style="width:auto"
          @click="customButtonClick"
        >
          Click here
        </button> -->
      </div>
    </quill-editor>
  <div class="mt-50" style="font-size:12px;">Last Edited : {{note.updated_at}}</div>
<template #modal-footer="{ ok , closeModal }">
    <!-- Button with custom close trigger value -->
      <b-button size="sm" variant="primary" @click="save()">
        Save
    </b-button>
    <!-- <b-button size="sm" variant="outline-secondary" @click="close()">
        Close
    </b-button> -->
</template>
      </b-modal>
  <b-nav-item @click="start_note()">
    <feather-icon
      size="21"
      :icon="'EditIcon'"
    />
  </b-nav-item>
  </div>
</template>

<script>

import { BNavItem, BButton, BModal,BFormTextarea } from 'bootstrap-vue'
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
export default {
  components: {
    BNavItem,
    quillEditor,
    BFormTextarea,
    BButton, BModal
  },
  data() {
    return {
        editorOption: {
            theme: 'snow',
            placeholder: 'Please enter note here...',

      modules: {
        toolbar: '#toolbar',
      },
    },
      userData: JSON.parse(localStorage.getItem('userData')),
        note: '',
    }
  },
  methods : {

        close() {
            this.$refs['modal-note'].hide()
        },
        save() {
            this.$http.post(process.env.VUE_APP_API_BASE + '/note/', {
                note: this.note.note
            }).then(res => {
                this.$refs['modal-note'].hide()
            })
        },
    start_note() {
        this.$http.get(process.env.VUE_APP_API_BASE + '/note/')
                .then(res => {
                    this.note = res.data.note

                })
            this.$refs['modal-note'].show()
    }
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  computed: {
   
  },
  created() {
   
  },
}
</script>

<style>

.quick-note-editor .ql-editor {
  min-height: 40em;
}

</style>

